export default "__VITE_ASSET__Z6OvYo7G__"